const translateWeather = {
  be: {
    200: 'навальніца з невялікім дажджом',
    201: 'навальніца з дажджом',
    202: 'навальніца з моцным дажджом',
    210: 'невялікая навальніца',
    211: 'навальніца',
    212: 'моцная навальніца',
    221: 'навальніца',
    230: 'навальніца з невялікай імглой',
    231: 'навальніца з імглой',
    232: 'навальніца з моцнай імглой',
    300: 'невялікая імгла',
    301: 'лёгкі дождж, імгла',
    302: 'кароткачасовы дождж',
    310: 'невялікая імгла з дажджом',
    311: 'лёгкі дождж',
    312: 'лёгкі інтэнсіўны дождж',
    313: 'кароткачасовы дождж з імглой',
    314: 'моцны кароткачасовы дождж з імглой',
    321: 'кароткачасовая імгла',
    500: 'лёгкі дождж',
    501: 'умераны дождж',
    502: 'моцны дождж',
    503: 'вельмі моцны дождж',
    504: 'лівень',
    511: 'дождж з градам',
    520: 'лёгкі кароткачасовы дождж',
    521: 'кароткачасовы дождж',
    522: 'моцны кароткачасовы дождж',
    531: 'кароткачасовыя дажджы',
    600: 'невялікі снег',
    601: 'снег',
    602: 'моцны снег',
    611: 'мокры снег',
    612: 'кароткачасовы мокры снег',
    615: 'лёгкі снег з дажджом',
    616: 'снег з дажджом',
    620: 'лёгкі кароткачасовы снег',
    621: 'кароткачасовы снег',
    622: 'моцны кароткачасовы снег',
    701: 'туман',
    711: 'дым',
    721: 'лёгкі туман',
    731: 'віхор пяску і пылу',
    741: 'туман',
    751: 'пясок',
    761: 'пыл',
    762: 'вулканічны попел',
    771: 'шквалы',
    781: 'тарнада',
    800: 'ясна',
    801: 'невялікая воблачнасць',
    802: 'воблачна',
    803: 'пераменная воблачнасць',
    804: 'пахмурна',
  },
  ru: {
    200: 'гроза с небольшим дождем',
    201: 'гроза с дождем',
    202: 'гроза с проливным дождем',
    210: 'небольшая гроза',
    211: 'гроза',
    212: 'сильная гроза',
    221: 'гроза',
    230: 'гроза с небольшим туманом',
    231: 'гроза с туманом',
    232: 'гроза с сильным туманом',
    300: 'маленький туман',
    301: 'легкий дождь, туман',
    302: 'кратковременный дождь',
    310: 'маленький туман с дождем',
    311: 'легкий дождь',
    312: 'легкий сильный дождь',
    313: 'кратковременный дождь с туманом',
    314: 'сильный кратковременный дождь с туманом',
    321: 'кратковременный туман',
    500: 'легкий дождь',
    501: 'умеренный дождь',
    502: 'сильный дождь',
    503: 'очень сильный дождь',
    504: 'дождь',
    511: 'дождь с градом',
    520: 'легкий прерывистый дождь',
    521: 'кратковременный дождь',
    522: 'сильный прерывистый дождь',
    531: 'кратковременные дожди',
    600: 'маленький снег',
    601: 'снег',
    602: 'сильный снегопад',
    611: 'мокрый снег',
    612: 'кратковременный мокрый снег',
    615: 'легкий снег с дождем',
    616: 'снег с дождем',
    620: 'кратковременный легкий снег',
    621: 'кратковременный снег',
    622: 'кратковременный сильный снегопад',
    701: 'туман',
    711: 'дым',
    721: 'легкий туман',
    731: 'вихрь песка и пыли',
    741: 'туман',
    751: 'песок',
    761: 'пыль',
    762: 'вулканический пепел',
    771: 'шквалы',
    781: 'торнадо',
    800: 'ясно',
    801: 'слегка облачно',
    802: 'облачно',
    803: 'переменная облачность',
    804: 'пасмурно',
  },
  en: {
    200: 'thunderstorm with light rain',
    201: 'thunderstorm with rain',
    202: 'thunderstorm with heavy rain',
    210: 'light thunderstorm',
    211: 'thunderstorm',
    212: 'heavy thunderstorm',
    221: 'ragged thunderstorm',
    230: 'thunderstorm with light drizzle',
    231: 'thunderstorm with drizzle',
    232: 'thunderstorm with heavy drizzle',
    300: 'light intensity drizzle',
    301: 'drizzle',
    302: 'heavy intensity drizzle',
    310: 'light intensity drizzle rain',
    311: 'drizzle rain',
    312: 'heavy intensity drizzle rain',
    313: 'shower rain and drizzle',
    314: 'heavy shower rain and drizzle',
    321: 'shower drizzle',
    500: 'light rain',
    501: 'moderate rain',
    502: 'heavy intensity rain',
    503: 'very heavy rain',
    504: 'extreme rain',
    511: 'freezing rain',
    520: 'light intensity shower rain',
    521: 'shower rain',
    522: 'heavy intensity shower rain',
    531: 'ragged shower rain',
    600: 'light snow',
    601: 'Snow',
    602: 'Heavy snow',
    611: 'Sleet',
    612: 'Light shower sleet',
    615: 'Light rain and snow',
    616: 'Rain and snow',
    620: 'Light shower snow',
    621: 'Shower snow',
    622: 'Heavy shower snow',
    701: 'mist',
    711: 'Smoke',
    721: 'Haze',
    731: 'sand/ dust whirls',
    741: 'fog',
    751: 'sand',
    761: 'dust',
    762: 'volcanic ash',
    771: 'squalls',
    781: 'tornado',
    800: 'clear sky',
    801: 'few clouds',
    802: 'scattered clouds',
    803: 'broken clouds',
    804: 'overcast clouds',
  },
};

export default translateWeather;
